import {
	ifAuthenticated,
	ifAuthenticatedOnline,
	canAccess,
	AppTabs,
	Edit,
	Create,
	Crud,
	trans
} from '@/router/index'

import Taskboard from '@/components/common/Taskboard'
import Project from '@/components/modules/projects/Project'
import GanttView from '@/components/modules/projects/GanttView'
import ProjectTabs from '@/components/modules/projects/ProjectTabs'
import ProjectCommission from '@/components/modules/projects/ProjectCommission'
import ProjectsSettings from '@/components/modules/projects/settings/ProjectsSettings'

export const projects = [
	{
		path: '/projects',
		beforeEnter: ifAuthenticated,
		component: AppTabs,
		props: {
			tabs: [
				{
					to: '/projects/',
					text: 'Progetti',
					module: 'projects'
				},
				{
					to: '/projects/planning',
					text: 'Pianificazione',
					module: 'projects'
				},
			],
		},
		children: [
			{
				path: '/projects/',
				name: 'projects-index',
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('module', 'projects', next) },
				component: Crud,
				meta: {
					title: trans('projects')
				},
				props: {
					modelDef: 'projects',
					actionIcon: 'web',
					title: 'Progetti',
					styleClass: 'mb-offset'
				}
			},
			{
				path: '/projects/planning',
				name: 'projects-planning',
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('module', 'projects', next) },
				component: GanttView,
				meta: {
					title: 'Pianificazione Progetti'
				}
			},
		],
	},
	{ 
		path: '/projects/create',
		name: 'projects-create',
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		meta: {
			title: 'Nuovo Progetto'
		},		
		props: (route) => ({
			modelDef: 'projects',
			defaultInput: route.params.defaultInput ? route.params.defaultInput : null,
			redirect: route.params.redirect
		}),
	},
	{ 
		path: '/projects/:id/edit',
		name: 'projects-edit',
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		meta: {
			title: 'Modifica Progetto'
		},				
		props: (route) => ({
			modelDef:  'projects',
			id: parseInt(route.params.id),
		}),
	},
	{
		path: '/projects/:id/',
		beforeEnter: ifAuthenticatedOnline,
		component: ProjectTabs, 
		props: (route) => ({
			id: parseInt(route.params.id),
		}), 
		children: [
			{
				path: '',
				name: 'projects-show',
				beforeEnter: ifAuthenticatedOnline,
				component: Project,
				meta: {
					title: 'Progetto'
				},
				props: (route) => ({
					id: parseInt(route.params.id),
				}),
			},
			{
				path: 'commission',
				name: 'projects-commission',
				beforeEnter: (to, from, next) => canAccess('setting', 'project_commission', next),
				component: ProjectCommission,
				meta: {
					title: 'Commessa'
				},
				props: (route) => ({
					id: parseInt(route.params.id),
				})
			},
			{
				path: 'quotations',
				beforeEnter: (to, from, next) => canAccess('module', 'quotations', next),
				component: Crud,
				meta: {
					title: 'Preventivi'
				},
				props: (route) => {
					// I query param possono essere array (param ripetuti) o stringhe non valide
					const pickQuery = (v) => Array.isArray(v) ? v[0] : v
					const defaultInput = {project_id: parseInt(route.params.id)}
					// Precompila azienda e titolo (nome progetto) quando si crea dal tab Preventivi
					const companyId = parseInt(pickQuery(route.query.company_id))
					if (!isNaN(companyId)) {
						defaultInput.company_id = companyId
					}
					const projectName = pickQuery(route.query.project_name)
					if (projectName) {
						defaultInput.name = projectName
					}
					return {
						modelDef: 'quotations',
						actionIcon: 'library_books',
						title: 'Preventivi',
						styleClass: 'mb-offset',
						subFilters: {projects: parseInt(route.params.id)},
						defaultInput: defaultInput,
					}
				}
			},
			{
				path: 'taskboard',
				beforeEnter: (to, from, next) => canAccess('module', 'tasks', next),
				component: Taskboard,
				meta: {
					title: 'Taskboard'
				},
				props: (route) => ({
					listableId: parseInt(route.params.id),
					listableType: 'project',
				})
			},
			{
				path: 'timecards',
				beforeEnter: (to, from, next) => canAccess('module', 'timecards', next),
				component: Crud,
				meta: {
					title: 'Timecard'
				},
				props: (route) => ({
					modelDef: 'timecards',
					actionIcon: 'alarm',
					title: 'Timecard',
					styleClass: 'mb-offset',
					subFilters: {projects: parseInt(route.params.id)},
					defaultInput: {project_id: parseInt(route.params.id)},
					// Le timecard non hanno una pagina di dettaglio: si aprono
					// nel dialog di modifica, come nella lista principale
					crudDialog: true,
				})
			},				
		]
	},	
	{ 
		path: '/settingsprojects/',
		name: 'settingsprojects',
		// impostazioni: senza il permesso Impostazioni la pagina non si apre (le API rispondono comunque 403)
		beforeEnter: (to, from, next) => ifAuthenticatedOnline(to, from, (redirect) => redirect
			? next(redirect)
			: canAccess('role', ['settings', 'index'], next)),
		component: AppTabs,
		props: {
			tabs: [
				{
					to: '/settingsprojects',
					text: 'Progetti',
				},		
			],
		},
		children: [
			{
				path: '/settingsprojects/',
				beforeEnter: ifAuthenticatedOnline,
				component: ProjectsSettings,
			},	
		],
	},
]